import { SuretyQuoteUnderwritingStatus } from "@inrev/common";
import { ProcessingBanner } from "@portal/components/features/banners";
import { FC } from "react";

export type AdminBondRequestProcessingBannerProps = {
	underwritingStatus?: SuretyQuoteUnderwritingStatus;
};

export const AdminBondRequestProcessingBanner: FC<AdminBondRequestProcessingBannerProps> = ({
	underwritingStatus,
}) => {
	if (underwritingStatus !== SuretyQuoteUnderwritingStatus.processing) {
		return null;
	}

	return (
		<ProcessingBanner
			testId="admin-bond-request-processing-banner"
			title="Extracting and Analyzing Documents"
			description="Document data is being extracted. Underwriting will complete automatically once processing is finished."
		/>
	);
};
